import {
    FETCHING_CLEVERSTORY_DOMAINS,
    FETCHING_CLEVERSTORY_DOMAINS_SUCCEEDED,
    FETCHING_CLEVERSTORY_DOMAINS_FAILED,
    CREATING_CLEVERSTORY_DOMAIN_REQUEST,
    CREATING_CLEVERSTORY_DOMAIN_SUCCEEDED,
    CREATING_CLEVERSTORY_DOMAIN_FAILED,
    UPDATING_CLEVERSTORY_DOMAIN_REQUEST,
    UPDATING_CLEVERSTORY_DOMAIN_SUCCEEDED,
    UPDATING_CLEVERSTORY_DOMAIN_FAILED,
    UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_REQUEST,
    UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_SUCCEEDED,
    UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_FAILED,
    DELETING_CLEVERSTORY_DOMAIN_REQUEST,
    DELETING_CLEVERSTORY_DOMAIN_SUCCEEDED,
    DELETING_CLEVERSTORY_DOMAIN_FAILED
  } from "constants/actionTypes";
  
  const initState = {
    items: [],
    loading: false,
  
    createDomain: {
      creating: false,
      success: false,
      error: null,
    },
    updateDomain: {
      updating: false,
      success: false,
      error: null,
    },
    fetchingDomains: {
      loading: false,
      success: false,
      error: null,
    },
    deleteDomain: {
      deleting: false,
      success: false,
      error: null
    }
  };
  
  function cleverstoryDomainsReducer(state = initState, action) {
    switch (action.type) {
      case CREATING_CLEVERSTORY_DOMAIN_REQUEST: {
        return {
          ...state,
          createDomain: { creating: true, error: null }
        };
      }
  
      case CREATING_CLEVERSTORY_DOMAIN_SUCCEEDED: {
        var records = state.items.records;
        records = [...records, action.payload]
        return {
          ...state,
          items: {
            ...state.items,
            records: records
          },
          createDomain: { creating: false, success: true, error: null }
        };
      }
  
      case CREATING_CLEVERSTORY_DOMAIN_FAILED: {
        let error =
          action.payload && action.payload.errors
            ? action.payload.errors[0].message
            : null;
        return {
          ...state,
          createDomain: { creating: false, error: error }
        };
      }
  
      case FETCHING_CLEVERSTORY_DOMAINS: {
        return Object.assign({}, state, {
          ...state,
          fetchingDomains: { loading: true, error: null },
          items: [],
          loading: true,
        });
      }
  
      case FETCHING_CLEVERSTORY_DOMAINS_SUCCEEDED: {
        var items = action.payload;
        return {
          ...state,
          fetchingDomains: { loading: false, success: true, error: null },
          items: items,
          loading: false,
        };
      }
  
      case FETCHING_CLEVERSTORY_DOMAINS_FAILED: {
        let error =
          action.payload && action.payload.errors
            ? action.payload.errors[0].message
            : null;
  
        return {
          ...state,
          fetchingDomains: { fetching: false, success: false, error: error },
          items: [],
          loading: false,
        };
      }

      case UPDATING_CLEVERSTORY_DOMAIN_REQUEST: {
        return  {
          ...state,
          updateDomain: { updating: true, error: null }
        };
      }
  
      case UPDATING_CLEVERSTORY_DOMAIN_SUCCEEDED: {
        var records = state.items.records;
        var index = records.findIndex((item) => {
          return item.id === action.payload.id;
        })
        records[index] = action.payload;
        return {
          ...state,
          items: {
            ...state.items,
            records: records
          },
          updateDomain: { updating: false, success: true, error: null }
        };
      }
  
      case UPDATING_CLEVERSTORY_DOMAIN_FAILED: {
        let error =
          action.payload && action.payload.errors
            ? action.payload.errors[0].message
            : null;
        return {
          ...state,
          updateDomain: { updating: false, error: error }
        };
      }

      case UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_REQUEST: {
        return  {
          ...state,
          loading: true
        };
      }
  
      case UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_SUCCEEDED: {
        var records = state.items.records;

        var index = records.findIndex((item) => {
          return item.id === action.payload.id;
        })
        records.forEach((item) => {
           item.primary = false;
        })
        records[index] = action.payload;
        return {
          ...state,
          loading: false,
          items: {
            ...state.items,
            records: records
          }
        };
      }
  
      case UPDATING_CLEVERSTORY_DOMAIN_AS_PRIMARY_FAILED: {
        let error =
          action.payload && action.payload.errors
            ? action.payload.errors[0].message
            : null;
        return {
          ...state,
          loading: false,
          error: error
        };
      }

      case DELETING_CLEVERSTORY_DOMAIN_REQUEST: {
        return {
          ...state,
          deleteDomain: { deleting: true, error: null }
        };
      }
  
      case DELETING_CLEVERSTORY_DOMAIN_SUCCEEDED: {
        var records = [...state.items.records];
        var index = records.findIndex((item) => {
          return item.id === action.payload.id;
        })
        records.splice(index,1);
        return {
          ...state,
          items: {
            ...state.items,
            records: records
          },
          deleteDomain: { deleting: false, success: true, error: null }
        };
      }
  
      case DELETING_CLEVERSTORY_DOMAIN_FAILED: {
        let error =
          action.payload && action.payload.errors
            ? action.payload.errors[0].message
            : null;
        return  {
          ...state,
          deleteDomain: { deleting: false, error: error }
        };
      }
  
      default:
        return state;
    }
  }
  
  export { cleverstoryDomainsReducer };
  